"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IconNotificationAlert", {
  enumerable: true,
  get: function get() {
    return _IconNotificationAlert.default;
  }
});
Object.defineProperty(exports, "IconNotificationClose", {
  enumerable: true,
  get: function get() {
    return _IconNotificationClose.default;
  }
});
var _IconNotificationAlert = _interopRequireDefault(require("./IconNotificationAlert"));
var _IconNotificationClose = _interopRequireDefault(require("./IconNotificationClose"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }